import React, { Component } from 'react';

export default class ReciboMapaViagem extends Component {

    exibirCorpoTabelaEncomenda() {
        return this.props.mapaViagemEncomenda.map((mapa, index) => <tr key={`mapa-itinerario-${index}`}>
                <th>{index + 1}</th>
                <td colSpan={2}>{mapa.trecho}<br/>{mapa.dataHoraSaida}</td>
                <td>{mapa.quantidadeSobem}</td>
                <td>{mapa.quantidadeDescem}</td>
            </tr>)
    }

    exibirEncomenda() {
        if (this.props.mapaViagemEncomenda && this.props.mapaViagemEncomenda.length && !this.props.eHmapaViagemPessoa) { 
            return (
                <div ref={this.props.referencias ? this.props.referencias.get('MAPA_VIAGEM_ENCOMENDA').referencia : null}>
                    <div className='row col-12'>
                        {this.exibirCabecalho()}
                    </div>
                    <div className='row col-12 mt-2'>
                        <table border="1" className="text-center recibo-mapa-viagem"
                            style={{ border: '1px solid #c8ced3' }}>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th colSpan={2}>Trecho/Horário</th>
                                    <th>Sobem</th>
                                    <th>Descem</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.exibirCorpoTabelaEncomenda()}
                            </tbody>
                            <tfoot style={{ backgroundColor: 'white' }}>
                                <tr>
                                    <td colSpan={2}><strong>Qtd agências: {this.props.mapaViagemEncomenda && this.props.mapaViagemEncomenda.length}</strong></td>
                                    <td><strong>Totais</strong></td>                            
                                    <td>{this.props.mapaViagemEncomenda.map(it => it.quantidadeSobem).reduce((sum, current) => Number(sum) + Number(current))}</td>
                                    <td>{this.props.mapaViagemEncomenda.map(it => it.quantidadeDescem).reduce((sum, current) => Number(sum) + Number(current))}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            )
        }
        
        return ''
    }

    exibirMapaViagemCorpoTabela() {
        return this.props.mapaViagem.map((mapa, index) => <tr key={`mapa-itinerario-${index}`}>
                <th>{index + 1}</th>
                <td colSpan={2}>{mapa.trecho}<br/>{mapa.dataHoraSaida}</td>
                <td>{mapa.quantidadeSobem}</td>
                <td>{mapa.quantidadeDescem}</td>                
            </tr>)
    }

    exibirCabecalho() {
        return (
            <table className="printer-ticket">
                <thead>
                    <tr>
                        <th colSpan="3">
                            {this.props.rotaSelecionada ? `${this.props.rotaSelecionada.value}: ${this.props.rotaSelecionada.label}` : ''}
                        </th>
                    </tr>
                    <tr>
                        <th colSpan="3">
                            {this.props.itinerarioSelecionado.dataHoraPartida}
                        </th>
                    </tr>
                    {this.props.itinerarioSelecionado.prestador && <tr>
                        <th colSpan="3">
                            Prestador:  {this.props.itinerarioSelecionado.prestador.valor}
                        </th>
                    </tr>}
                </thead>
            </table>
        )
    }

    exibir() {
        if (this.props.mapaViagem && this.props.mapaViagem.length && this.props.eHmapaViagemPessoa) {
            return (
                <div ref={this.props.referencias ? this.props.referencias.get('MAPA_VIAGEM').referencia : null}>
                    <div className='row col-12'>
                        {this.exibirCabecalho()}
                    </div>
                    <div className='row col-12 mt-2'>
                        <table border="1" className="text-center recibo-mapa-viagem"
                            style={{ border: '1px solid #c8ced3' }}>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th colSpan={2}>Trecho/Horário</th>
                                    <th>Sobem</th>
                                    <th>Descem</th>                                
                                </tr>
                            </thead>
                            <tbody>
                                {this.exibirMapaViagemCorpoTabela()}
                            </tbody>
                            <tfoot style={{ backgroundColor: 'white' }}>
                                <tr>
                                    <td colSpan={2}><strong>Qtd <br/> agências: {this.props.mapaViagem && this.props.mapaViagem.length}</strong></td>
                                    <td><strong>Totais</strong></td>                            
                                    <td>{this.props.mapaViagem.map(it => it.quantidadeSobem).reduce((sum, current) => Number(sum) + Number(current))}</td>
                                    <td>{this.props.mapaViagem.map(it => it.quantidadeDescem).reduce((sum, current) => Number(sum) + Number(current))}</td>                                
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            )
        }
        return ''
    }

    render() {
        return (
            <>
                {this.exibir()}
                {this.exibirEncomenda()}
            </>
        )
    }
}